import React, { Component } from 'react';
import ReactDom from 'react-dom';
import MyAccount from './components/my-account';
import { Provider } from 'react-redux';
import store from './store';
import './tools';

export default class MyAccountRoot extends Component {

	render() {
		return (
			<Provider store={store}>
				<MyAccount />
			</Provider>
		);
	}
}

var MyAccountElement = document.getElementById( 'MyAccountRootElement' );
if ( MyAccountElement ) {
	ReactDom.render( <MyAccountRoot />, MyAccountElement );
}
